/**
 * Created by Languagenut on 10/09/2019.
 */


import React  from 'react';
import VocabularyBlock from './generating_vocabulary_block.js';
import {Button , Card , Row , Col , Navbar , Nav , ProgressBar} from 'react-bootstrap'
import FieldGroup from '../FieldGroup.js';
import Import from './vocabulary_import_popup.js'
import LanguageSelect from '../language_select.js';

import Translation from '../../store/internationalization-store.js'
import {ProductService} from '../../services';
import {ProductStore} from '../../store';
import Constants from '../../constants.js'
import ContentService from '../../services/content-service.js';
import Package from '../../classes/package.js';

function isDataURL(s) {
    if (s == false || s == undefined) {
        return false;
    }
    return !!String(s).match(isDataURL.regex);
}

isDataURL.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

export default class Vocabulary extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            import:false,
            vocabularies:[],
            images:{

            },
            name:'',
            description:'',
        };

        this.limit = 1;
        this.noImage = true;
        this.vocabularies = [];
    }

    componentWillMount(){
        ProductStore.on(Constants.GET_LANGUAGES ,  ()=>{
            console.log(ProductStore.getLanguages())
        });
    }

    componentDidMount(){
        ProductService.getAllLanguages();
    }

    onVocabularyImport(vocabularies){

        var v = this.vocabularies;

        for(var idx = 0 ; idx < vocabularies.length; idx++)
        {
            v.push({
                uid:idx,
                learning:vocabularies[idx].learning,
                support:vocabularies[idx].support
            })
        }

        this.vocabularies = v;
        this.setState({
            import:false
        })


    }

    addVocabulary() {
        let vocabs = this.vocabularies;
            vocabs.push({uid:vocabs.length});

        this.vocabularies = vocabs;

        this.setState({
            update:true
        })
    }

    onRemove(index) {
        var vocabs = [];
        for (var i = 0; i < this.vocabularies.length; i++) {
            if (i == index) {
                vocabs.push(null);
            } else {
                vocabs.push(this.vocabularies[i]);
            }
        }

        this.vocabularies = vocabs;
        this.setState({
            update:true
        })
    }

    getVocabularies(){

        let arr = [];

        for(var idx = 0 ; idx < this.vocabularies.length; idx++)
        {
            if(this.vocabularies[idx] == null) {
                arr.push(null);
            } else {
                if (this.vocabularies[idx].valid == undefined) {
                    this.vocabularies[idx].valid = true;
                }
                arr.push(<VocabularyBlock incorrect={!this.vocabularies[idx].valid} onUpdate={this.onUpdate.bind(this)} 
                        languageIETF={this.state.learning} supportIETF={this.state.support} support={this.vocabularies[idx].support} 
                        learning={this.vocabularies[idx].learning} onDeleted={this.onRemove.bind(this)} index={idx} />)
            }
        }

        return arr
    }

    onUpdate(config , index){

        let vocabs = this.vocabularies
            vocabs[index] = config;

        this.vocabularies = vocabs;
    }

    makeVocaularies(index , vocabular , catalogUID){

        var vocab = vocabular[index];

        this.setState({
            made:index,
        });

        if(!vocab)
        {
            if(vocabular.length < 8)
            {
                ContentService.unPublish(catalogUID).then(function(){
                    this.setState({
                        saving:false
                    });
                    window.location.hash = '#/library/custom_content'
                }.bind(this))
            }
            else
            {
                this.setState({
                    saving:false
                });
                window.location.hash = '#/library/custom_content'
            }


            return;
        }


        var vocabUID     = vocab.uid
        var learningtext = vocab.learning;
        var supportText  = vocab.support;
        var imageDataUrl = vocab.picture;


        var imageIsDataURL = isDataURL(imageDataUrl);

        var learnDataUrl   = vocab.learningAudio;
        var supportDataUrl = vocab.supportAudio;
        var learnIsDataURL   = isDataURL(learnDataUrl);
        var supportIsDataURL = isDataURL(supportDataUrl);

        ContentService.makeVocab(catalogUID , this.state.learning , this.state.support , learningtext , supportText , imageIsDataURL , imageDataUrl , learnIsDataURL , supportIsDataURL , learnDataUrl , supportDataUrl , false).then(function(){


            this.makeVocaularies(++index , vocabular , catalogUID)
        }.bind(this));
    }

    makeModule(){



        var vocabs = [];


        for(var i = 0 ; i < this.vocabularies.length; i++)
        {
            if(!this.vocabularies[i] || this.vocabularies[i] == null) continue;

            vocabs.push(this.vocabularies[i]);
        }

        this.vocabularies = vocabs;

        this.setState({
            saving:true,
            made:0,
            tomake:this.vocabularies.length
        });

        if(this.vocabularies.length < this.limit)
        {
            this.setState({saving:false});
            return;
        }

        ContentService.makeNewModule(this.state.name , this.state.learning , this.state.support , this.state.description).then(function(response){
            this.makeVocaularies(0 , this.vocabularies , response.uid);

        }.bind(this))

    }

    getProgress(){
        return (this.state.made/this.state.tomake)*100;
    }


    getError(){

        if(this.state.fileError)
        {
            return   <div class="alert alert-danger" role="alert">
                {Translation.get(12780, 'You have missing images or audios please review the vocabulary cards')}
            </div>
        }


        if(this.state.namingError)
        {
            return   <div class="alert alert-danger" role="alert">
                {Translation.get(12781, 'Name and description can\'t be blank')}
            </div>
        }


        return null;
    }

    save()
    {
        if(this.state.name == '' || this.state.description == '')
        {
            this.setState({
                namingError:true
            })
            return
        }

        if(this.vocabularies.length <  this.limit)
        {
            return;
        }

        let valid = true;

        for(var idx = 0 ; idx < this.vocabularies.length; idx++) {

            var vocab = this.vocabularies[idx]
            if (vocab == null) {
                continue;
            }
            var isSecondary = (new Package()).isSecondary();
            if(!vocab.learning || !vocab.support || (!vocab.picture && !isSecondary) || !vocab.supportAudio || !vocab.learningAudio)
            {
                vocab.valid = false;
                valid = false;
            }
        }

        if(!valid)
        {
            this.setState({
                fileError:true
            })
            return
        }

        this.makeModule();
    }

    getLanguage(){
        return  <Row>
    <Col md={6}><LanguageSelect priority={this.state.learning} returnValue={(language)=>{ console.log(language); 
        sessionStorage.setItem("packageUid", language.packageUid); 
        this.setState({learning:language.ietf}) }} title={Translation.get(2211, 'Learning Language')}/></Col>
<Col md={6}><LanguageSelect isInterface={true} singularOnly={true} priority={(new Package()).isDutch() ? 'nl' : 'en'} returnValue={
(language)=>{
    this.setState({support:language.ietf})
}
} title={Translation.get(2212 , 'Support Language')}/></Col>
</Row>
    }

    render(){

        if(this.state.saving) return <ProgressBar animated now={this.getProgress()} />
        var vocabItemsNeeded = <center>{Translation.get(12645, 'Please create a minimum of 8 vocabulary pairs before saving')}</center>
        if (this.vocabularies.length >=  this.limit) {
            vocabItemsNeeded = "";
        }
        var vocabItems = this.getVocabularies();
        return <div>
                <Import
                        show={this.state.import}
                        onHide={() => {this.setState({import:false})}}
                        onImport={this.onVocabularyImport.bind(this)}
                    />
                <Card body>
                    <Row>
                        <Col md={4}><FieldGroup style={{background:(this.state.name == "")?"#ffe6e6":"#ffffff"}} autoFocus={true}  onChange={(event)=>{this.setState({name:event.target.value})}} value={this.state.name} label={Translation.get(2202 , 'Title')}/></Col>
                        <Col md={8}><FieldGroup style={{background:(this.state.description == "")?"#ffe6e6":"#ffffff"}} onChange={(event)=>{this.setState({description:event.target.value})}} value={this.state.description} label={Translation.get(2203 , 'Description')}/></Col>
                    </Row>
                        {this.getLanguage()}
                    <Row>
                        <Col md={11}>
                            {this.getError()}
                        </Col>
                        <Col md={1}><Button disabled={this.vocabularies.length <  this.limit} onClick={this.save.bind(this)} className='float-right'>{Translation.get(657 , 'Save')}</Button></Col>
                        
                    </Row>
                </Card>
                <br/>
                <Card body>
                    <a class="hyperlink" onClick={()=>{this.setState({import:true})}}>{Translation.get(12641 , '+ Import from Word, Excel, Google Docs, etc.')}</a>
                    <br/>
                    <br/>
                    {vocabItems}
                    {vocabItemsNeeded}
                    <br/>
                    <center><Button block onClick={this.addVocabulary.bind(this)} class='hyperlink'>{Translation.get(2210 , 'Add Vocabulary')}</Button></center>
                    <br/>
                    <center><Button disabled={this.vocabularies.length <  this.limit} onClick={this.save.bind(this)} className='float-right'>{Translation.get(657 , 'Save')}</Button></center>

                    </Card>
            </div>
    }
}